<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> 查看 </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <span class="page-title">项目底层企业信息</span>
    </div>
    <div class="content-container">
      <div class="container">
        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">项目名称</span>
            </div>
            <div class="field-content">
              {{ sectionOne.projectName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">项目公司</span>
            </div>
            <div class="field-content">
              {{ sectionOne.companyName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">项目备案容量</span>
            </div>
            <div class="field-content">
              {{ sectionOne.projectRecord }} MW
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">所在区域</span>
            </div>
            <div class="field-content">
              {{ sectionOne.regionFullName + sectionOne.address }}
              <img v-if="locationScreenshot.imageUrl" :src="locationScreenshot.imageUrl" @click="onPreviewImage(locationScreenshot.imageUrl)" alt="avatar" class="uploaded-img"/>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">底层企业名称</span>
            </div>
            <div class="field-content">
              {{ sectionOne.enterpriseName }}
              <p class="sub-label">主要经营产品或业务</p>
              {{ sectionOne.businessScope }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">底层企业营业执照</span>
            </div>
            <div class="field-content">
              <p v-for="doc in licenseDoc.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">企业处于正常经营状态</span>
            </div>
            <div class="field-content">
              <p>{{ sectionOne.bizHealth }}</p>
              <p v-if="sectionOne.bizHealth==='不符合'">备注说明：{{ sectionOne.bizHealthRemark }}</p>
              <p v-if="bizHealthScreenshot.imageUrl">--查询截图--</p>
              <img v-if="bizHealthScreenshot.imageUrl" :src="bizHealthScreenshot.imageUrl" alt="avatar" @click="onPreviewImage(bizHealthScreenshot.imageUrl)" class="uploaded-img"/>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">企业未曾被列入失信执行人</span>
            </div>
            <div class="field-content">
              <p>{{ sectionOne.dishonest }}</p>
              <p v-if="sectionOne.bizHealth!=='曾被列入'">{{ sectionOne.dishonestRemark }}</p>
              <p v-if="honestScreenshot.imageUrl">--查询截图--</p>
              <img v-if="honestScreenshot.imageUrl" :src="honestScreenshot.imageUrl" @click="onPreviewImage(honestScreenshot.imageUrl)" alt="avatar" class="uploaded-img"/>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">企业查询无明显经营风险</span>
            </div>
            <div class="field-content">
              <p>{{ sectionOne.businessRisk }}</p>
              <p v-if="sectionOne.businessRisk==='不符合'">备注说明：{{ sectionOne.businessRiskRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">需要具备土地证、产权证、或租赁协议（但需要提供房东的土地证、产权证），如无产权证，需附土地证、工程规划许可证、施工许可证、竣工验收证明、消防验收证明</span>
            </div>
            <div class="field-content">
              <p>{{ sectionOne.landUser }}</p>
              <p v-if="landCert.docList.length>0">--土地证--</p>
              <p v-if="landCert.docList.length>0">
                <span class="eff-dates-label">土地证有效期：</span>{{ sectionOne.landCertStartYm }} 至 {{ sectionOne.landCertExpireYm }} <span v-if="sectionOne.landCertDateRemark" class="remark-label">情况备注：</span>{{ sectionOne.landCertDateRemark }}
              </p>
              <p v-for="doc in landCert.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="ownerCert.docList.length>0">--产权证--</p>
              <p v-if="ownerCert.docList.length>0">
                <span class="eff-dates-label">产权证有效期：</span>{{ sectionOne.ownerCertStartYm }} 至 {{ sectionOne.ownerCertExpireYm }} <span v-if="sectionOne.ownerCertDateRemark" class="remark-label">情况备注：</span>{{ sectionOne.ownerCertDateRemark }}
              </p>
              <p v-for="doc in ownerCert.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="leaseAgreement.docList.length>0">--租赁协议--</p>
              <p v-if="leaseAgreement.docList.length>0">
                <span class="eff-dates-label">租赁协议有效期：</span>{{ sectionOne.leaseAgreeStartYm }} 至 {{ sectionOne.leaseAgreeExpireYm }} <span v-if="sectionOne.leaseAgreeDateRemark" class="remark-label">情况备注：</span>{{ sectionOne.leaseAgreeDateRemark }}
              </p>
              <p v-for="doc in leaseAgreement.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="engineeringPermit.docList.length>0">--工程规划许可证--</p>
              <p v-for="doc in engineeringPermit.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="constructionPermit.docList.length>0">--施工许可证--</p>
              <p v-for="doc in constructionPermit.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="completionCert.docList.length>0">--竣工验收证明--</p>
              <p v-for="doc in completionCert.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="fireSafetyCert.docList.length>0">--消防验收证明--</p>
              <p v-for="doc in fireSafetyCert.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">房屋产权清晰、无纠纷</span>
            </div>
            <div class="field-content">
              <p>{{ sectionOne.rightsClear }}</p>
              <p v-if="sectionOne.rightsClear==='不符合'">备注说明：{{ sectionOne.rightsClearRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label optional-field field-label__bold">自发自用项目企业属性</span>
            </div>
            <div class="field-content">
              <p>{{sectionOne.operatorType}}</p>
              <p v-if="existenceCert.docList.length>0">--持续性经营证明文件--</p>
              <p v-for="doc in existenceCert.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <DocPreview ref="docPreview" />
    <a-modal :visible="imgPreviewVisible" :width="1000" :footer="null" @cancel="imgPreviewVisible = false">
      <img :src="imgPreviewUrl" style="width: 100%" />
    </a-modal>
  </a-layout>
</template>
<script>
import {loadSectionOne} from "@/services/SpecService";
import {baseURL} from "@/services/HttpService";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import DocPreview from "@/views/DocPreview.vue";

export default {
  components: {DocPreview, BreadcrumbItem, Breadcrumb},
  props: {
    projectId: String
  },
  data() {
    return {
      imgPreviewVisible: false,
      imgPreviewUrl: "",
      viewUrl: baseURL + "/attachment?fileName=",
      sectionOne: {
        projectName: "",
        companyId: "",
        companyName: "",
        enterpriseName:"",
        regionFullName: "",
        licenseImgUrl: "",
        projectRecord: "",
        state: "",
        landUser: "",
        rightsClear: "",
        rightsClearRemark: "",
        operatorType: "",
        bizHealth: "",
        bizHealthRemark: "",
        bizHealthImageUrl: "",
        dishonest: "",
        dishonestRemark: "",
        businessRisk: "",
        businessRiskRemark: "",
        address: "",
        locationImageUrl: "",
      },
      licenseDoc: {
        loading: false,
        docList: [],
        title: ""
      },
      landCert: {
        loading: false,
        docList: [],
        title: "土地证"
      },
      ownerCert: {
        loading: false,
        docList: [],
        title: "产权证"
      },
      leaseAgreement: {
        loading: false,
        docList: [],
        title: "租赁协议"
      },
      existenceCert: {
        loading: false,
        docList: [],
        title: "持续性经营证明文件"
      },
      honestScreenshot: {
        loading: false,
        imageUrl: "",
        title: "查询截图"
      },
      bizHealthScreenshot: {
        loading: false,
        imageUrl: "",
        title: "查询截图"
      },
      locationScreenshot: {
        loading: false,
        imageUrl: "",
        title: "卫星地图位置截图"
      },
      engineeringPermit: {
        loading: false,
        docList: [],
        title: "工程规划许可证"
      },
      constructionPermit: {
        loading: false,
        docList: [],
        title: "施工许可证"
      },
      completionCert: {
        loading: false,
        docList: [],
        title: "竣工验收证明"
      },
      fireSafetyCert: {
        loading: false,
        docList: [],
        title: "消防验收证明"
      },
    };
  },
  mounted() {
    this.startLoadSectionOne();
  },
  methods:{
    getCompanyId(){
      return this.sectionOne.companyId;
    },
    startLoadSectionOne(){
      if(this.projectId && this.projectId!=="" && this.projectId !== "0") {
        loadSectionOne(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            if(data.dishonestImageUrl) {
              this.honestScreenshot.imageUrl = this.viewUrl + data.dishonestImageUrl;
            }
            if(data.bizHealthImageUrl) {
              this.bizHealthScreenshot.imageUrl = this.viewUrl + data.bizHealthImageUrl;
            }
            if(data.locationImageUrl) {
              this.locationScreenshot.imageUrl = this.viewUrl + data.locationImageUrl;
            }
            if(data.address===undefined || data.address===null) {
              data.address = "";
            }
            this.sectionOne = data;

            this.buildDocList(data.bizDocList, 'bizDoc');
            this.buildDocList(data.licenseDocList, 'licenseDoc');
            this.buildDocList(data.landCertDocList, 'landCert');
            this.buildDocList(data.ownerCertDocList, 'ownerCert');
            this.buildDocList(data.leaseAgreementDocList, 'leaseAgreement');
            this.buildDocList(data.existenceCertDocList, 'existenceCert');
            this.buildDocList(data.engineeringPermitDocList, 'engineeringPermit');
            this.buildDocList(data.constructionPermitDocList, 'constructionPermit');
            this.buildDocList(data.completionCertDocList, 'completionCert');
            this.buildDocList(data.fireSafetyCertDocList, 'fireSafetyCert');
          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    preview(doc) {
      this.$refs.docPreview.previewFile(doc);
    },
    onPreviewImage(url){
      if(url && url !== "") {
        this.imgPreviewUrl = url;
        this.imgPreviewVisible = true;
      }
    }

  }
}
</script>
<style scoped>
.sub-label {
  margin-top: 1em;
  margin-bottom: 4px;
  font-weight: bold;
}
.remark-label {
  margin-left: 10px;
}
.eff-dates-label {
  display: inline-block;
  width: 8em;
}
</style>